import { CoverageTypeEnum } from "@platform/types";

import { COVERAGE_TYPE_TO_API_NAME, DOCUMENT_TYPE_LABELS } from "./constants";

import type { DocumentLibraryCoverageType } from "./coverage-type";
import type { DocumentType } from "./types";

export function coverageTypeToLabel(
  coverageType: DocumentLibraryCoverageType,
): string {
  return COVERAGE_TYPE_TO_API_NAME[coverageType];
}

export function documentTypeToLabel(documentType: DocumentType): string {
  return DOCUMENT_TYPE_LABELS[documentType];
}

export function isCoverageTypeEnum(value: string): value is CoverageTypeEnum {
  return Object.values(CoverageTypeEnum).includes(value as CoverageTypeEnum);
}

export function isPdf(value?: string | null): boolean {
  const normalizedValue = value?.trim();
  if (!normalizedValue) {
    return false;
  }
  return /\.pdf($|[?#])/i.test(normalizedValue);
}

function downloadURI(link: string, name: string): void {
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = link;
  a.download = name;
  a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export const downloadBinaryFile = (
  binaryFile: BlobPart,
  fileName: string,
): void => {
  const blob = new Blob([binaryFile], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  downloadURI(url, fileName);
  URL.revokeObjectURL(url);
};

// Poor signal: infers upload origin from the SharePoint path segment rather than a
// persisted source field. The backend should add an `upload_source` field to AIDocument
// (e.g. "analyst" | "broker") so the origin can be determined reliably without
// coupling the frontend to the SharePoint folder structure.
export function isAnalystDocument(sharepointURL: string): boolean {
  return sharepointURL.includes("analyst-documents");
}
